import React, { createContext, useContext, useState } from 'react';

const AposentadosDemitidosContext = createContext({});

export function useAposentadosDemitidos() {
    const context = useContext(AposentadosDemitidosContext);
    return context;
}

export function AposentadosDemitidosProvider({ children }) {
    const [dataAposentadosDemitidos, setDataAposentadosDemitidos] = useState({});
    const [dataContrato, setDataContrato] = useState({});
    const [dataDocuments, setDataDocuments] = useState([]);
    const [dataBeneficiario, setDataBeneficiario] = useState({});
    const [dataInputForm, setDataInputForm] = useState({});
    const [alerts, setAlerts] = useState([]);
    const [dataMovimentacao, setDataMovimentacao] = useState({});

    function clearAposentadosDemitidos() {
        setDataDocuments({});
        setDataDocuments([]);
        setDataBeneficiario({});
        setDataInputForm({});
        setAlerts([]);
        setDataMovimentacao({});
    }

    return (
        <AposentadosDemitidosContext.Provider
            value={{
                dataAposentadosDemitidos,
                setDataAposentadosDemitidos,
                dataContrato,
                setDataContrato,
                dataDocuments,
                setDataDocuments,
                dataBeneficiario,
                setDataBeneficiario,
                clearAposentadosDemitidos,
                dataInputForm,
                setDataInputForm,
                alerts,
                setAlerts,
                dataMovimentacao,
                setDataMovimentacao,
            }}
        >
            {children}
        </AposentadosDemitidosContext.Provider>
    );
}
